import { Button, cn, humanize } from "@esp/ui";
import { useState } from "react";
import { NavLink, Outlet } from "react-router";

import { useStaff } from "../auth/staff";

const NAV = [
  { to: "/", label: "Overview", end: true },
  { to: "/enquiries", label: "Enquiries" },
  { to: "/organizations", label: "Organizations" },
  { to: "/users", label: "Users" },
  { to: "/plans", label: "Plans" },
  { to: "/starter-templates", label: "Starter templates" },
  { to: "/analytics", label: "Analytics" },
  { to: "/deliverability", label: "Deliverability" },
  { to: "/risk", label: "Risk events" },
  { to: "/messages", label: "Message lookup" },
  { to: "/mail-queue", label: "Mail queue" },
  { to: "/suppressions", label: "Global suppressions" },
  { to: "/infrastructure", label: "SMTP & IPs" },
  { to: "/audit", label: "Audit log" },
];

/** Deliberately different from the customer dashboard: dark chrome and a Staff label. */
export function AdminShell() {
  const { staff, signOut } = useStaff();
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[15rem_1fr]">
      <aside className={cn("bg-slate-900 px-3 py-4 text-slate-200 lg:sticky lg:top-0 lg:block lg:h-screen", open ? "block" : "hidden")}>
        <div className="mb-6 px-3">
          <p className="text-xs font-semibold tracking-widest text-red-400 uppercase">Staff</p>
          <p className="flex items-center gap-2 text-lg font-semibold text-white">
            <img src="/brand/icon.png" alt="" className="size-7 rounded-md" />
            Platform admin
          </p>
        </div>
        <nav aria-label="Admin">
          <ul className="space-y-0.5">
            {NAV.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    cn("block rounded-md px-3 py-2 text-sm", isActive ? "bg-slate-700 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white")
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      <div className="min-w-0">
        <header className="sticky top-0 z-10 flex h-14 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 sm:px-6">
          <Button variant="ghost" size="sm" className="lg:hidden" aria-expanded={open} onClick={() => setOpen((v) => !v)}>Menu</Button>
          <div className="flex-1" />
          <span className="hidden text-sm text-slate-600 sm:inline">
            {staff.email} · <strong>{humanize(staff.role)}</strong>
          </span>
          <Button size="sm" variant="secondary" onClick={() => void signOut()}>Sign out</Button>
        </header>
        <main className="mx-auto max-w-6xl px-4 py-6 sm:px-6 lg:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
